/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { ClientId } from '../../models/client-id';
import { TimetableFlights } from '../../models/timetable-flights';

export interface GetTimetableForRoute$Params {

/**
 * IATA code for airport, city or country
 */
  originLocationCode: string;

/**
 * IATA code for airport, city or country
 */
  destinationLocationCode: string;

/**
 * Flight date (yyyy-MM-dd)
 */
  departureDate: string;

/**
 * Number of days to return, starting from departure date. Range: 1-35.
 */
  numberOfDays?: number;

/**
 * Search direct flights only
 */
  directFlights?: boolean;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
}

export function getTimetableForRoute(http: HttpClient, rootUrl: string, params: GetTimetableForRoute$Params, context?: HttpContext): Observable<DapiHttpResponse<TimetableFlights>> {
  const rb = new DapiRequestBuilder(rootUrl, getTimetableForRoute.PATH, 'get');

  if (params) {
    rb.query('originLocationCode', params.originLocationCode, {});
    rb.query('destinationLocationCode', params.destinationLocationCode, {});
    rb.query('departureDate', params.departureDate, {});
    rb.query('numberOfDays', params.numberOfDays, {});
    rb.query('directFlights', params.directFlights, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<TimetableFlights>;
    }),
    catchErrorAsJson()
  );
}

getTimetableForRoute.PATH = '/api/timetable';
